// extracted by mini-css-extract-plugin
export var hidden = "_so-0";